import { useState } from "react";
import { SubNavEducationBar } from "@similarweb/ui-components";
import { translate } from "app/filters/i18nFilter";
import { EducationalVideoModal } from "pro-features/components/Modals/src/EducationalVideoModal";
import type { EducationData } from "app/pages/sales-intelligence/types/educationData";
import { ArticlesService } from "app/components/React/EducationBarContainer/ArticlesService";
import { showIntercomTour } from "app/services/IntercomProductTourService";
import type { EducationArticle } from "../../types";

export type EducationBarProps = {
    educationData: Readonly<EducationData>;
    onClose(): void;
    onGetStartedClick(article: EducationArticle): void;
};

const EducationBar = ({ educationData, onClose, onGetStartedClick }: EducationBarProps) => {
    const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

    async function handleGetStartedClick() {
        const {
            id,
            title,
            draft: active,
            body: content,
            html_url: link,
        }: any = await ArticlesService.GetArticleById(educationData.zendesk);

        onGetStartedClick({
            id,
            link,
            title,
            active,
            content,
            docType: 1,
            attachments: [],
        });
    }

    function getGetStartedClickHandler() {
        if (typeof educationData.zendesk === "undefined") {
            return undefined;
        }

        return handleGetStartedClick;
    }

    function getWatchVideoClickHandler() {
        if (typeof educationData.video === "undefined") {
            return undefined;
        }

        return () => setIsVideoModalOpen(true);
    }

    function getTourClickHandler() {
        if (typeof educationData.intercom === "undefined") {
            return undefined;
        }

        return () => showIntercomTour(educationData.intercom);
    }

    return (
        <>
            <SubNavEducationBar
                onCloseEducationBar={onClose}
                onTourClick={getTourClickHandler()}
                onGetStartedClick={getGetStartedClickHandler()}
                onWatchVideoClick={getWatchVideoClickHandler()}
                videoText={translate("education.bar_see.video_button")}
                helpText={translate("education.bar_see.article_button")}
                tourText={translate("education.bar_see.tour_button")}
                extraMarginBottom={false}
            />
            <EducationalVideoModal
                shouldCloseOnOverlayClick
                videoConfig={{
                    url: `https://vimeo.com/${educationData.video}`,
                    videoConfig: {
                        autoPlay: true,
                        width: "100%",
                        height: "100%",
                    },
                }}
                isOpen={isVideoModalOpen}
                onCloseClick={() => setIsVideoModalOpen(false)}
            />
        </>
    );
}

export default EducationBar;
